import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Image from 'next/image';
import { mergeClasses } from '@/utils/style';
const SIZE = 168;
const SIZE_LARGE = 368;
export function ImageItem(t0) {
  const $ = _c(11);
  const {
    src,
    width,
    height,
    className
  } = t0;
  let t1;
  if ($[0] !== className || $[1] !== height || $[2] !== width) {
    t1 = mergeClasses("overflow-hidden", {
      "col-span-2": width === 2
    }, {
      "row-span-2": height === 2
    }, {
      "rounded-2xl": width < 2 || height < 2
    }, {
      "rounded-2xl lg:rounded-4xl": width === 2 && height === 2
    }, className);
    $[0] = className;
    $[1] = height;
    $[2] = width;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = width === 2 ? SIZE_LARGE : SIZE;
  const t3 = height === 2 ? SIZE_LARGE : SIZE;
  let t4;
  if ($[4] !== src || $[5] !== t2 || $[6] !== t3) {
    t4 = <Image src={src} alt="Image" width={t2} height={t3} className="h-full w-full object-cover" />;
    $[4] = src;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t1 || $[9] !== t4) {
    t5 = <div className={t1}>{t4}</div>;
    $[8] = t1;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}